export default function getAppTrackingParams(url) {
  const pathname = window.location.pathname;

  if (pathname.includes('lizing-meditsinskogo-oborudovaniya')) {
    return {
      app_channel: 'thematic_landing',
      app_source: 'lizing-meditsinskogo-oborudovaniya',
      landing_url: url,
      channel: 'thematic_landing',
      landing_slug: 'medicine',
    };
  }

  if (pathname.includes('lizing-auto')) {
    return {
      app_channel: 'thematic_landing',
      app_source: 'lizing-auto',
      landing_url: url,
      channel: 'thematic_landing',
      landing_slug: 'auto',
    };
  }

  if (pathname.includes('robots')) {
    return {
      app_channel: 'thematic_landing',
      app_source: 'robots',
      landing_url: url,
      channel: 'thematic_landing',
      landing_slug: 'robots',
    };
  }

  if (pathname.includes('shiny-v-lizing')) {
    return {
      app_channel: 'thematic_landing',
      app_source: 'shiny-v-lizing',
      landing_url: url,
      channel: 'thematic_landing',
      landing_slug: 'shini',
    };
  }

  if (process.env.GATSBY_PARTNER_SLUG) {
    return {
      app_channel: 'partner_landing',
      app_source: process.env.GATSBY_PARTNER_SLUG,
      landing_url: url,
      channel: 'partner_landing',
      landing_slug: process.env.GATSBY_PARTNER_SLUG,
    };
  }

  if (process.env.REGION_SLUG) {
    return { channel: 'city_landing', landing_slug: process.env.REGION_SLUG };
  }

  return { app_channel: 'main_site', landing_url: url, channel: 'main_site' };
}
